import Vue from 'vue'
import App from './App.vue'
import store from './store'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/css/askmeslot-style.css'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import i18n from './i18n'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

Vue.axios.defaults.headers.common['x-result-askmeslot'] = 'TGI18jk3IOACMzRjMDhhOTQyMjQ4YjijNDMzZDZk789='
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
